module.exports = __webpack_public_path__ + "images/home/orientation/new-user.c95fada45e5b8a72f20d.svg";